import apiClient from '../../api/client';
import { apiError, downloadCsv, toCsv } from '../format';

const COLUMNS = [
  { label: 'Name', value: 'name' },
  { label: 'Business', value: 'business_name' },
  { label: 'Subdomain', value: 'subdomain' },
  { label: 'Email', value: 'email' },
  { label: 'Phone', value: 'phone' },
  { label: 'Status', value: 'status' },
  { label: 'Conversions', value: 'conversions' },
  { label: 'Rate %', value: (r) => Math.round(r.commission_rate * 1000) / 10 },
  { label: 'Earned (Rs)', value: 'commission' },
  { label: 'Paid (Rs)', value: 'commission_paid' },
  { label: 'Balance owed (Rs)', value: 'commission_balance' },
  { label: 'Categories', value: 'market_focus' },
  { label: 'Joined', value: (r) => (r.created_at || '').slice(0, 10) },
];

/** Download resellers (all, or matching the given search/status) as a CSV file. */
export async function exportResellers(params, notify) {
  try {
    const { data } = await apiClient.get('/admin/resellers', { params: { ...params, limit: 1000 } });
    downloadCsv(`resellers-${new Date().toISOString().slice(0, 10)}.csv`, toCsv(COLUMNS, data.items));
    notify(`Exported ${data.items.length} reseller${data.items.length === 1 ? '' : 's'}`);
  } catch (err) {
    notify(apiError(err, 'Export failed'), 'error');
  }
}
